module.exports = __webpack_public_path__ + "static/kemal-5708eb2c89a7548d949e909614154622.jpeg";